import { Link } from 'react-router-dom';
import React from "react";
import Navigation from "../component/Navigation";
import Footer from "../component/Footer";
import ".././css/contactUs.css"; 
import '.././css/button.css';
import smile from '.././images/smiley-bk.png'




function ContactUsPage() {
    document.title = 'Kontakt os'
    document.getElementsByTagName('meta')["keywords"].content = "keywords!!";
    document.getElementsByTagName('meta')["description"].content = "Contacts os";
    return (
        <div>
            <Navigation />
                {/* for at få flere på rækken, skal der bare laves flere text classes*/}
            
            <meta name="description" content=""></meta>
             <div>
                <div className='contactBody'>
                  {/* <div className="aboutSection"> */}
                     <div className="innerContainer">
                         <h2 class="contactheading">Kontakt os</h2>
                            <p className="conText">
                           <span>Altid klar til at hjælpe vores kunder </span>
                           <span>Du kan kontakte os her: </span>
                           <span>Email: jeffie@amazon.com </span>
                           <span>Telefon: +45 00 00 00 00 </span>
                           <span>Facebook.com/Novuservers </span>
                           <span>https://discord.gg/Dj8Cmd2DERs </span>
                           <span>Instagram.com/Novuservers </span>
                           <span>Twitter.com/Novuservers </span>
                           {/* <span>Bitcoin addresse: 3AJ6dMzcHqYtjAtjVWsQFRPoy35CC8schE </span> */}
{/*                            
                            Du kan kontakte os her:
                            
                            Email: jeffie@amazon.com
                            
                            Telefon: +45 00 00 00 00
                            
                            Facebook.com/Novuservers
                           
                            https://discord.gg/Dj8Cm2DERs
                            
                            Instagram.com/Novuservers
                            
                            Twitter.com/Novuservers
                            
                            Bitcoin addresse: 3AJ6dMzcHqYtjAtjVWsQFRPoy35CC8schE  */}
                            </p>

                        </div>
                    {/* </div> */}
                    <div className ="contactimg">
                     <img src={smile} alt="logo" />
                     {/* <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" />
                     <img src={smile} alt="logo" /> */}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ContactUsPage;



                   
                            {/* <div className="text">
                            <div className="skills">
                                <div className="dropdown">
                                    <span>Server</span>
                                    <div class="dropdown-content">
                                        <p>Hello World!</p>
                                    </div>
                                </div>
                                <div className="dropdown">
                                    <span>Games</span>
                                    <div class="dropdown-content">
                                        <p>Hello World!</p>
                                    </div>
                                </div>
                                <div className="dropdown">
                                    <span>Code</span>
                                    <div class="dropdown-content">
                                        <p>Hello World!</p>
                                    </div>
                                </div>
                                </div>
                            </div> */}